import React, {Component} from 'react'
import FilterTypeError from './FilterTypeError'
import FilterSku from './FilterSku'
import FilterBarcode from './FilterBarcode'
import FilterDetailError from './FilterDetailError'
import FilterPrinter from './FilterPrinter'
import FilterDateMark from './FilterDateMark'
import FilterMarker from './FilterMarker'

class ListItemMarkErrorFilters extends Component{
    render() {
        return (
            <div className="ReGenerateFilters mb-3 pt-3 pl-3 pr-3">
                <div className="d-flex align-items-center" style={{flexWrap: 'wrap'}}>
                    <FilterBarcode {...this.props}/>
                    <FilterSku {...this.props}/>
                    <FilterTypeError {...this.props}/>
                    <FilterDetailError {...this.props}/>
                    <FilterPrinter {...this.props}/>
                    <FilterMarker {...this.props}/>
                    <FilterDateMark {...this.props}/>
                </div>
            </div>
        )
    }
}

export default ListItemMarkErrorFilters